import { BaseEntity } from "yt-ng-framework";

export class Period extends BaseEntity{
    constructor(){
        super();
    };

    GenericName: string = null;
    Naziv: string = null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.GenericName = input.GenericName;
        this.Naziv = input.Naziv;
        return this;
    }

    Serialize(input: Period) {
        return input;
    }
}